import { IPatient } from '../unsw-fhir/Patient';
import {
  ICarePlan,
  CarePlanIntent,
  CarePlanStatus,
  ICarePlanActivityComponent,
  CarePlanActivityStatus,
} from '../unsw-fhir/CarePlan';
import {
  createPatientReference,
  createOrganizationReference,
  IReference,
} from '../unsw-fhir/Reference';
import { IOrganization } from '../unsw-fhir/Organization';

export const generateCarePlan = ({
  patient,
  organization,
  title,
  intent = 'plan',
  status = 'active',
  description,
}: {
  patient: IPatient;
  organization: IOrganization;
  title: string;
  intent?: CarePlanIntent;
  status?: CarePlanStatus;
  description?: string;
}) => {
  const carePlan: ICarePlan = {
    resourceType: 'CarePlan',
    title,
    intent,
    status,
    description,
    subject: createPatientReference(patient.id!),
    author: createOrganizationReference(organization.id!),
    activity: [],
  };

  return carePlan;
};

export const createActivity = ({
  reasonReference,
  definition,
  status = 'in-progress',
}: {
  reasonReference?: IReference;
  definition?: IReference;
  status?: CarePlanActivityStatus;
}): ICarePlanActivityComponent => {
  const activity: ICarePlanActivityComponent = {
    detail: {
      status,
    },
  };

  if (reasonReference) {
    activity.detail!.reasonReference = [reasonReference];
  }
  if (definition) {
    activity.detail!.definition = definition;
  }
  return activity;
};
